/* [ASB] Dawn 15.4.0 file with custom edits — search '[ASB' below.
   Edits: [ASB pdp] hand image-only product galleries to the full-screen zoom (assets/asb-product-zoom.js)
   when the modal has data-asb-zoom. Built by: Codex (2026-10). */
if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        this.asbZoom?.close(); /* [ASB pdp] */
        super.hide();
      }

      show(opener) {
        super.show(opener);
        /* [ASB pdp] START — full-screen zoom for the compact product page */
        if (this.hasAttribute('data-asb-zoom') && window.ASBProductZoom) {
          this.asbZoom ||= new window.ASBProductZoom(this);
          this.asbZoom.open(opener);
          return;
        }
        /* [ASB pdp] END */
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
